import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from '../ui/dialog';

export const FormModal = ({ isOpen, onClose, title, children }) => {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent 
        className="sm:max-w-[600px] rounded-none border border-slate-200 p-0 gap-0"
        data-testid="form-modal"
        aria-describedby="form-modal-description"
      >
        <DialogHeader className="bg-slate-900 text-white p-6">
          <DialogTitle className="text-lg font-semibold uppercase tracking-wider">
            {title}
          </DialogTitle>
          <DialogDescription id="form-modal-description" className="sr-only">
            Fill out the form below to submit your interest
          </DialogDescription>
        </DialogHeader>
        <div className="p-6 bg-slate-50">
          {children}
        </div>
      </DialogContent>
    </Dialog>
  );
};
